import { render } from "./produto-editar.vue?vue&type=template&id=38c27f66&scoped=true"
import script from "./produto-editar.vue?vue&type=script&lang=js"
export * from "./produto-editar.vue?vue&type=script&lang=js"

import "./produto-editar.vue?vue&type=style&index=0&id=38c27f66&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Administrador\\PhpstormProjects\\mtex_mobagile_m3_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38c27f66"]])

export default __exports__